import React from 'react'
import provider3 from "../../Includes/Images/human-1.jpg";

function WideCoverage() {
  return (
    <>
    <section class="spec-hero-section">
<div class="spec-hero-image-container">
    {/* <img src={provider3} alt="Professional woman working at desk" class="spec-hero-image" /> */}
    <div class="spec-blue-tab-top"></div>
    <div class="spec-blue-tab-bottom"></div>
<div class="spec-hero-content spec">
    <p class="spec-blue-text">Enjoy the Wide Coverage</p>
    <h1 class="spec-heading-primary">Our Wide Spread Network Covers USA</h1>
    <p class="spec-paragraph">Our Expansive Network Spans Across The United States, Ensuring Comprehensive Coverage From Coast To Coast With Reliable Connectivity.</p>
    <a href="#" class="spec-btn-blue">Read More</a>
</div>
</div>
</section>

<section class="spec-services-section">
<h2 class="spec-services-label">Services</h2>
<h2 class="spec-heading-services">Best Services That Make<br />Everything Easy</h2>
<p class="spec-services-subtitle">Committed to offer most reliable services for your ease and comfort.</p>


<div class="spec-services-grid">
    <div class="spec-service-cardd">
        <div class="spec-service-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <circle cx="12" cy="12" r="4"></circle>
                <line x1="21.17" y1="8" x2="12" y2="8"></line>
                <line x1="3.95" y1="6.06" x2="8.54" y2="14"></line>
                <line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>
            </svg>
        </div>
        <h3 class="spec-service-title">Internet</h3>
        <p class="spec-service-description">Use the internet how it meant to be - fast, reliable, and consistent, with a ton of data at a budget-friendly price.</p>
    </div>

    <div class="spec-service-cardd spec-tv-card">
        <div class="spec-service-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect>
                <polyline points="17 2 12 7 7 2"></polyline>
            </svg>
        </div>
        <h3 class="spec-service-title">TV</h3>
        <p class="spec-service-description">Browse TV plans from cable, satellite, and streaming services to find the perfect fit for you.</p>
    </div>

    <div class="spec-service-cardd">
        <div class="spec-service-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
            </svg>
        </div>
        <h3 class="spec-service-title">Compare Providers</h3>
        <p class="spec-service-description">Draw an easy comparison among the providers available in your area with our expert reviews and solicited evaluations.</p>
    </div>
</div>

{/* <a href="#" class="spec-btn-outline">View All Services</a> */}
</section>
    </>
  )
}

export default WideCoverage